// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
        import * as Sentry from "@sentry/react";

        const ErrorBoundary: FC = ({ children }) => (
          <Sentry.Profiler>
            <Sentry.ErrorBoundary>
              {children}
            </Sentry.ErrorBoundary>
          </Sentry.Profiler>
        );

        export function rootContainer(container) {
          return React.createElement(ErrorBoundary, null, container);
        }
